import { styled } from "@mui/material";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { TabConfig } from "../types";
import { compactCount } from "../utils";
import useLang from "Shared/hooks/useLanguage";
import { AutocompleteStyle } from "Utils/MuiStyles/AutocompleteStyles";

const TabSelected = styled(Tab)(AutocompleteStyle());

interface Props {
  tabs: TabConfig[];
  value: number;
  counts: Record<number, number>;
  onChange: (tabId: number) => void;
}

// Portal tab strip (same look as v1 View Requisition) with cached counts.
const WorklistTabs = ({ tabs, value, counts, onChange }: Props) => {
  const { t } = useLang();
  return (
    <Tabs
      value={value}
      onChange={(_, v: number) => onChange(v)}
      className="min-h-auto"
      TabIndicatorProps={{
        style: { background: "transparent", cursor: "pointer" },
      }}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        "& .MuiTabs-scrollButtons": {
          width: 0,
          transition: "width 0.7s ease",
          "&:not(.Mui-disabled)": { width: "48px" },
        },
      }}
    >
      {tabs.map((tab) => {
        const n = compactCount(counts[tab.tabId]);
        return (
          <TabSelected
            key={tab.tabId}
            value={tab.tabId}
            data-test-id={tab.tabName.replace(/\s/g, "")}
            className="fw-bold text-capitalize"
            label={`${t(tab.tabName)}${n === undefined ? "" : ` (${n})`}`}
          />
        );
      })}
    </Tabs>
  );
};

export default WorklistTabs;
